module.exports = __webpack_public_path__ + "static/media/image-4.355cd4fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Apteligent/image-4.png
// module id = 254
// module chunks = 0